'use es6';

import { Component } from 'react';
import AdjacentPortal from './AdjacentPortal';

/**
 * @param {Object} props
 * @param {string} props.id (required)
 * @param {string} [props.namespace] (optional)
 * @param {Element} props.targetElement (required)
 * @param {React.ReactNode} props.children (required)
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default class AfterEndPortal extends Component {
  render() {
    const {
      id,
      namespace,
      targetElement,
      children
    } = this.props;
    return /*#__PURE__*/_jsx(AdjacentPortal, {
      id: id,
      namespace: namespace,
      targetElement: targetElement,
      targetPosition: 'afterend',
      children: children
    });
  }
}